// Design-time gateway palette (shown in the editor / DEFAULT canvas).
export const GATEWAY_ACTIVE_COLOR = "#F5A623";
export const GATEWAY_DEFAULT_COLOR = "#999999";

// Neutral "not-run" colour used in the progress view, matching the default
// link stroke set by WorkflowProgressView.getColouredComponentLinks.
const NOT_RUN_COLOR = "var(--color-text-secondary)";

/**
 * Resolve how a gateway edge should render.
 *
 * In the editor a gateway branch is always drawn in the design-time palette
 * (orange for a condition, grey-dashed for the default branch) so authors can
 * see the branching. In the progress view that palette is wrong: it makes
 * every gateway branch look "active/taken" even in runs that never traversed
 * them (e.g. a session paused at the trigger). There, the edge must reflect
 * run state via the stroke the progress view already computed on the edge —
 * grey when the source never ran, source-status colour when it did — exactly
 * like a normal Link edge.
 *
 * ponytail: run-state colouring keys off the source node's status (the stroke
 * progress view stamps on the edge), so all branches out of a gateway that ran
 * share one colour. Highlighting only the specific taken branch would need the
 * session's selected-edge data plumbed through; matches existing Link behaviour.
 *
 * @param {{mode?: string, isDefault?: boolean, runStroke?: string}} args
 */
export function getGatewayEdgeRenderStyle({ mode, isDefault, runStroke }) {
  const isProgressView = mode === "PROGRESSVIEW";

  if (isProgressView) {
    const stroke = runStroke || NOT_RUN_COLOR;
    return {
      isProgressView: true,
      stroke,
      dashed: Boolean(isDefault),
      markerFill: stroke,
      labelBorder: stroke,
      labelBg: "var(--color-bg-paper)",
      labelColor: "var(--color-text-secondary)",
    };
  }

  return {
    isProgressView: false,
    stroke: isDefault ? GATEWAY_DEFAULT_COLOR : GATEWAY_ACTIVE_COLOR,
    dashed: Boolean(isDefault),
    markerFill: isDefault ? GATEWAY_DEFAULT_COLOR : GATEWAY_ACTIVE_COLOR,
    labelBorder: isDefault ? "#ccc" : "#F5A623",
    labelBg: isDefault ? "#f5f5f5" : "#FFF3E0",
    labelColor: isDefault ? "#666" : "#E65100",
  };
}
